module.exports = __webpack_public_path__ + "static/media/medisLogoWithoutText.9a7758b7.png";